export default __webpack_public_path__ + "static/bg-ab5dd5fd4daff55c520ca104b2c459e9.png";